import InfoTooltip from 'components/_UI/InfoTooltip';
import Paginate from 'components/_UI/Paginate';
import Table from 'components/_UI/Table'
import Text from 'components/_UI/Text'
import { useEvent } from 'context/events/Event';
import React, { useEffect, useState } from 'react'
import { Edit, Info, Trash2, UserCheck } from 'lucide-react';
import styled from 'styled-components';
import { FullyCentered } from 'styled/alignment/Center';
import { Row } from 'styled/alignment/Row';
import colors from 'theme/colors'
import expensesApi from 'api/requests/expenses';
import Loader from 'components/_UI/Loader';

import currency from 'helpers/currency';
import { panelAccent } from 'theme/panelAccent';

export default function ExpensesList({refreshExpenses, toggleAction}) {
    const [expenses, setExpenses] = useState([])
    const {event} = useEvent()
    const [lastPage, setLastPage] = useState(0)
    const [currentPage, setCurrentPage] = useState(0)
    const [perPage, setPerPage] = useState(0)
    const [totalItems, setTotalItems] = useState(0)
    const [isLoading, setIsloading] = useState(false)
    useEffect(() => {
        getExpenses()
    }, [refreshExpenses])

     async function getExpenses(number = 1) {
            
           const slugEvent = event?.slug;
            setIsloading(true)
            try {
                const {data} = await  expensesApi.get(slugEvent, number)
              
                setCurrentPage(data?.meta?.current_page)
                setLastPage(data?.meta?.last_page)
                setPerPage(data?.meta?.per_page)
                setTotalItems(data?.meta?.total)
                setExpenses(data?.data)
            } catch (error) {
                setIsloading(false)
            } finally {
                setIsloading(false)
            }
        }

    const listExpenses = expenses?.map(item => {
       
        return {
            name: <Text name='small'>{item?.name}</Text>,
            category: <Text name='small'>{item?.category}</Text>,
            status: <StyledStatus status={item.status}>{item.status === 1 ? 'Pago' : item.status === 0 ? 'Pendente' : item.status === 2 ? 'Orçamento' : ''}</StyledStatus>,
            amount: <Text name='small' type='bold'> {currency?.format(parseFloat(item?.amount))}</Text>,
            importance: <Text name='small'>{item?.importance_level ? item?.importance_level : 'Não informado'}</Text>,
            actions: (
                <>
                    <ContentAction marginRight>
                        <InfoTooltip
                            bgColor={colors.night}
                            text={'Visualizar Detalhes'}
                            type='none'
                        >
                            <Info size={20} color={colors.primaryLight} onClick={() => toggleAction({item, type: 'detail'})}/>
                        </InfoTooltip>
                    </ContentAction>
                    <ContentAction>
                        <InfoTooltip bgColor={colors.night} text={'Editar Despesa'} type='none'>
                            <Edit size={20} color={colors.primaryLight} onClick={() => toggleAction({item, type: 'edit'})}/>
                        </InfoTooltip>
                    </ContentAction>
                    <ContentAction>
                        <InfoTooltip bgColor={colors.night} text={'Excluir Despesa'} type='none'>
                            <CheckContainer> 
                                <Trash2 size={20} color={colors.danger} onClick={() => toggleAction({item, type: 'delete'})}/>
                            </CheckContainer>
                        </InfoTooltip>
                    </ContentAction>
                </>
            )
        };
    });




  return (
    <>
        <Text name='highlight' color={colors.nightDark} paddingBottom={0} paddingTop={'10px'}>
            Lista de Despesas
        </Text>
        {
            isLoading ? (
                <Loader />
            ) : (
                <>
                    <Table
                        rows={listExpenses}
                        columns={['Nome', 'Categoria', 'Status', 'Valor', 'Importância', 'Ações']}
                    />
                    {
                        lastPage > 1 &&
                        <Paginate
                            perPage={perPage}
                            totalItems={totalItems}
                            lastPage={lastPage}
                            firstPage={1}
                            currentPage={currentPage}
                            marginTop={'20px'}
                            onPaginate={(number) => getExpenses(number)}
                        />
                    }
                </>
            )

        }
        
    </>
  )
}


const ContentAction = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all ease-in-out 0.25s;

    ${({ marginRight }) => marginRight && `
       margin-right: 10px;
    `};

    & > div > svg {
        &:hover {
            transform: scale(1.1);
       }
    }
`

const StyledStatus = styled(Row)`
   
    width: 80px;
    align-items: center;
    text-transform: capitalize;
    padding: 5px 0;
    color: ${colors.neutralLight};
    /* font-size: 12px;
    font-weight: 600; */
     border-radius: 4px 30px 30px 4px;
     justify-content: center;
    

    ${({ status }) => status == 1  && `
        background: ${colors.successLight};
       
       
    `}
    
    ${({ status }) => status === 0 && `
         background: ${colors.occasionalOrange};
    `}

    ${({ status }) => status === 2 && `
         background: ${panelAccent(colors.occasionalPurple)};
    `}

`;

const CheckContainer = styled(FullyCentered)`
    width: 20px;
    height: 20px; 
    margin-left: 14px;
    margin-bottom: 2px;
`;